export const ANALYTICS_HOST = "https://analytics.swiggy.com";
